import React from 'react'
import { Box, Typography } from '@material-ui/core'

export default function TextInfoDisplay (props) {
  if (!props.children) return null

  return (
    <Box style={{ marginBottom: '10px' }}>
      <Typography variant='h6'>
        {props.label}
      </Typography>
      <Typography>
        {props.children}
      </Typography>
    </Box>
  )
}